<template>
	<div
		data-name="main-view"
		:class="this.$style['wrapper']"
	>
		<!-- <SeeThroughButton
			:class="$style.seeThroughButton"
			:text="'Win a Seventy2 Survival System'"
			@click.native="handleWinButtonClick"
    ></SeeThroughButton>-->

		<div
			v-if="info && info.mainView"
			:class="$style['content-wrapper']"
		>
			<div :class="$style['content-title']">{{ info.mainView.title }}</div>
			<div :class="$style['content-subtitle']">{{ info.mainView.subtitle }}</div>

			<div :class="$style.content">{{ info.mainView.content }}</div>
		</div>

    <div
      v-if="showThanks"
      :class="$style['form-thanks']"
    >
      <div :class="$style['info-wrapper']">
        <h3>Thanks!</h3>
        <p>You've been entered for a chance to win one of three emergency preparedness kits from Preppi!</p>
      </div>
    </div>


		<!-- commercial video -->
		<div
			:class="$style.commercialVideoContainer"
			@mouseover="handleMouseOver('commercial')"
			@mouseleave="handleMouseLeave('commercial')"
			@click="handleCommercialClick('commercial')"
		>
			<video
				muted
				playsinline
				webkit-playsinline
				loop
				:class="$style.commercialVideo"
				:poster="commercialPosterUrl"
			>
				<source
					:src="commercialVideoUrl"
					type="video/mp4"
				/>
			</video>
			<SplashScreenStartCard
				:title="'COMMERCIAL'"
				:text="''"
				:buildingType="'commercial'"
				:class="[this.$style.splashScreenStartCard, this.$style.commercialSplashCard]"
			></SplashScreenStartCard>
			<div :class="[$style.videoOverlay, $style.commercialVideoOverlay]"></div>
		</div>

		<!-- residential video -->
		<div
			:class="$style.residentialVideoContainer"
			@mouseover="handleMouseOver('residential')"
			@mouseleave="handleMouseLeave('residential')"
			@click="handleResidentialClick('residential')"
		>
			<video
				muted
				playsinline
				webkit-playsinline
				loop
				:class="$style.residentialVideo"
				:poster="residentialPosterUrl"
			>
				<source
					:src="residentialVideoUrl"
					type="video/mp4"
				/>
			</video>
			<SplashScreenStartCard
				:title="'RESIDENTIAL'"
				:text="''"
				:buildingType="'residential'"
				:class="[this.$style.splashScreenStartCard, this.$style.residentialSplashCard]"
			></SplashScreenStartCard>
			<div :class="[$style.videoOverlay, $style.residentialVideoOverlay]"></div>
		</div>

		<header-bar></header-bar>

		<!-- <introduction> </introduction> -->

		<!-- <how-to-play-card ref="howToPlayCard" v-on:instructionsConfirmed="handleInstructionConfirmed"></how-to-play-card> -->

		<transition
			@before-enter="beforeTestimonialsEnter"
			@enter="testimonialsEnter"
			@leave="testimonialsLeave"
			:css="false"
		>
			<testimonials v-if="appState === 'show-testimonials'"></testimonials>
		</transition>
	</div>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
import HeaderBar from "../HeaderBar.vue";
import UiButton from "../UiButton.vue";
import CommercialPlaneAnim from "../PlaneAnims/CommercialPlaneAnim.vue";
import ResidentialPlaneAnim from "../PlaneAnims/ResidentialPlaneAnim.vue";
import Introduction from "../Introduction.vue";
import { TweenMax, TimelineMax } from "gsap";
import isMobileMixin from "../../plugins/isMobileMixin.js";
import tweenSpeedsMixin from "../../plugins/tweenSpeedsMixin.js";
import Testimonials from "../Testimonials.vue";
import FinalScorePage from "./FinalScorePage.vue";
import SplashScreenStartCard from "../SplashScreenStartCard";
import SeeThroughButton from "../SeeThroughButton";
import MenuIcon from "../svgs/MenuIcon";

export default {
	name: "main-view",
	components: {
		HeaderBar,
		UiButton,
		CommercialPlaneAnim,
		Introduction,
		Testimonials,
		FinalScorePage,
		ResidentialPlaneAnim,
		SplashScreenStartCard,
		SeeThroughButton,
		MenuIcon
	},
	props: [],
	mixins: [isMobileMixin, tweenSpeedsMixin],
	data() {
		return {
			commercialVideoUrl: "../../../static/videos/commercial_1.mp4",
			commercialPosterUrl: "../../../static/images/poster-com-1.jpg",
			residentialVideoUrl: "../../../static/videos/residential_1.mp4",
			residentialPosterUrl: "../../../static/images/poster-res-1.jpg",
			commercialVideoEl: null,
      residentialVideoEl: null,
      showThanks: false,
			isTransitioningToNextPage: false
		};
	},
	computed: {
		...mapGetters({
			info: "content/all"
		}),
		appState: function() {
			return this.$store.getters.getAppState;
		},
		previousAppState: function() {
			return this.$store.getters.getPreviousAppState;
		}
	},
	watch: {

  },
	beforeCreate() {
		// this.$store.dispatch("content/retrieve");
	},
	mounted() {
		this.$store.dispatch("updateAppState", { state: "introduction" });

		setTimeout(() => {
			this.$bus.$emit("loader/toggle", false);
		}, 1000);

		this.commercialVideoEl = document.querySelector(
			"." + this.$style.commercialVideo
		);

		this.residentialVideoEl = document.querySelector(
			"." + this.$style.residentialVideo
    );

    this.$route;

    if (this.$route.name === "Thanks") {

      this.showThanks = true;

      setTimeout(() => {
        this.showThanks = false;
      }, 3000);

    }
	},
	methods: {
		handleMouseOver(type) {
			if (this.isMobile) return;
			if (this.isTransitioningToNextPage) return;

			this.$bus.$emit("intro-hover-on", type);

			if (type === "commercial") {
				// show commercial, hide residential
				// // tween the widths of videos
				// TweenMax.to("." + this.$style.commercialVideoContainer, 1.2, {
				// 	width: "65%",
				// 	ease: Power4.easeOut
				// });
				// TweenMax.to("." + this.$style.residentialVideoContainer, 1.2, {
				// 	width: "35%",
				// 	ease: Power4.easeOut
				// 	// x: 0.35 * window.innerWidth
				// });

				// scale video animation
				TweenMax.to("." + this.$style.commercialVideo, 1.2, {
					scale: 1.05,
					ease: Power4.easeOut
				});
				TweenMax.to("." + this.$style.residentialVideo, 1.2, {
					scale: 1.0,
					ease: Power4.easeOut
				});

				// play hovered video, pause unhovered
				this.commercialVideoEl.play();
				this.residentialVideoEl.pause();

				// show/hide overlay
				TweenMax.to("." + this.$style.commercialVideoOverlay, 1.2, {
					opacity: 0,
					ease: Power4.easeOut
				});
				TweenMax.to("." + this.$style.residentialVideoOverlay, 1.2, {
					opacity: 1,
					ease: Power4.easeOut
				});

				// show/hide splash card
				TweenMax.to("." + this.$style.commercialSplashCard, 0.5, {
					opacity: 1
				});
				TweenMax.to("." + this.$style.residentialSplashCard, 0.5, {
					opacity: 0
				});
			} else {
				// show residential, hide commercial
				// // tween the widths of videos
				// TweenMax.to("." + this.$style.commercialVideoContainer, 1.2, {
				// 	width: "35%",
				// 	ease: Power4.easeOut
				// });
				// TweenMax.to("." + this.$style.residentialVideoContainer, 1.2, {
				// 	width: "65%",
				// 	ease: Power4.easeOut
				// 	// x: 0.35 * window.innerWidth
				// });

				// scale video animation
				TweenMax.to("." + this.$style.commercialVideo, 1.2, {
					scale: 1.0,
					ease: Power4.easeOut
				});
				TweenMax.to("." + this.$style.residentialVideo, 1.2, {
					scale: 1.05,
					ease: Power4.easeOut
				});

				// play hovered video, pause unhovered
				this.residentialVideoEl.play();
				this.commercialVideoEl.pause();

				// show/hide overlay
				TweenMax.to("." + this.$style.commercialVideoOverlay, 1.2, {
					opacity: 1,
					ease: Power4.easeOut
				});
				TweenMax.to("." + this.$style.residentialVideoOverlay, 1.2, {
					opacity: 0,
					ease: Power4.easeOut
				});

				// show/hide splash card
				TweenMax.to("." + this.$style.commercialSplashCard, 0.5, {
					opacity: 0
				});
				TweenMax.to("." + this.$style.residentialSplashCard, 0.5, {
					opacity: 1
				});
			}
		},
		handleMouseLeave(type) {
			this.$bus.$emit("intro-hover-off", type);
		},
		handleCommercialClick(type) {
			this.isTransitioningToNextPage = true;
			this.commercialVideoEl.loop = false;

			this.fadeOutUI();

			this.hideContent();

			if (this.isMobile) {
				this.$bus.$emit("hide-win-button-for-transition");
				this.transitionCommercialVideoMobile();
			} else {
				this.transitionCommercialVideoDesktop();
			}
		},
		transitionCommercialVideoMobile() {
			// scale video back to normal
			TweenMax.to("." + this.$style.commercialVideo, 1.2, {
				scale: 1.0,
				ease: Power4.easeOut
			});
			// make height 100%
			TweenMax.to("." + this.$style.commercialVideoContainer, 2.0, {
				height: "100%",
				ease: Power4.easeOut
			});
			// shrink residential video and change route
			TweenMax.to("." + this.$style.residentialVideoContainer, 2.0, {
				height: "0%",
				ease: Power4.easeOut,
				onComplete: () => {
					this.$router.push("/commercial");
				}
			});
		},
		transitionCommercialVideoDesktop() {
			// scale video back to normal
			TweenMax.to("." + this.$style.commercialVideo, 1.2, {
				scale: 1.0,
				ease: Power4.easeOut
			});
			// make width 100%
			TweenMax.to("." + this.$style.commercialVideoContainer, 2.0, {
				width: "100%",
				ease: Power4.easeOut
			});
			// shrink residential video and change route
			TweenMax.to("." + this.$style.residentialVideoContainer, 2.0, {
				width: "0%",
				ease: Power4.easeOut,
				onComplete: () => {
					this.$router.push("/commercial");
				}
			});
		},
		handleResidentialClick(type) {
			this.isTransitioningToNextPage = true;
			this.residentialVideoEl.loop = false;

			this.fadeOutUI();

			if (this.isMobile) {
				this.$bus.$emit("hide-win-button-for-transition");
				this.transitionResidentialVideoMobile();
			} else {
				this.transitionResidentialVideoDesktop();
			}
		},
		transitionResidentialVideoMobile() {
			// scale video back to normal
			TweenMax.to("." + this.$style.residentialVideo, 1.2, {
				scale: 1.0,
				ease: Power4.easeOut
			});
			// make height 100%
			TweenMax.to("." + this.$style.residentialVideoContainer, 2.0, {
				height: "100%",
				ease: Power4.easeOut
			});
			// shrink commercial video and change route
			TweenMax.to("." + this.$style.commercialVideoContainer, 2.0, {
				height: "0%",
				ease: Power4.easeOut,
				onComplete: () => {
					this.$router.push("/residential");
				}
			});
		},
		transitionResidentialVideoDesktop() {
			// scale video back to normal
			TweenMax.to("." + this.$style.residentialVideo, 1.2, {
				scale: 1.0,
				ease: Power4.easeOut
			});
			// make width 100%
			TweenMax.to("." + this.$style.residentialVideoContainer, 2.0, {
				width: "100%",
				ease: Power4.easeOut
			});
			// shrink commercial video and change route
			TweenMax.to("." + this.$style.commercialVideoContainer, 2.0, {
				width: "0%",
				ease: Power4.easeOut,
				onComplete: () => {
					this.$router.push("/residential");
				}
			});
		},
		fadeOutUI() {
			// fade out get started buttons
			this.$bus.$emit("fade-out-get-started");

			// fade out win button
			this.$bus.$emit("fade-out-win-button");
		},
		handleInstructionConfirmed: function() {
			// this.$refs.PlaneAnim.handleInstructionConfirmed();
		},
		beforeTestimonialsEnter: function(el) {
			TweenMax.set(el, {
				y: "100%",
				opacity: 0
			});
		},
		testimonialsEnter: function(el, done) {
			TweenMax.to(el, this.tweenSpeeds.dur.testimonialsEnter, {
				y: "0%",
				opacity: 1,
				onComplete: done,
				ease: Power2.easeInOut
			});
		},
		testimonialsLeave: function(el, done) {
			TweenMax.to(el, this.tweenSpeeds.dur.testimonialsEnter, {
				y: "100%",
				opacity: 0,
				onComplete: this.handleFadePlayAgainButton.bind(this, done),
				ease: Power2.easeInOut
			});
		},
		beforeFinalScoreEnter: function(el) {
			if (this.previousAppState === "show-testimonials") {
				return;
			}

			TweenMax.set(el, {
				x: "100%",
				opacity: 0
			});
		},
		handleFinalScoreEnter: function(el, done) {
			if (this.previousAppState === "show-testimonials") {
				this.handleFadePlayAgainButton.bind(this, done);
				return;
			}

			TweenMax.to(
				"#finalScoreComponent",
				this.tweenSpeeds.dur.finalScoreEnter,
				{
					x: "0%",
					opacity: 1,
					onComplete: this.handleFadePlayAgainButton.bind(this, done)
				}
			);
		},
		handleFadePlayAgainButton: function(done) {
			TweenMax.to("#playAgainButton", this.tweenSpeeds.dur.itemFadeIn, {
				opacity: 1
			});
		},
		handleFinalScoreLeave: function(el, done) {
			// if(this.previousAppState === 'show-testimonials') {
			//   return;
			// }

			if (this.appState !== "intro-anim") {
				return;
			}

			TweenMax.to(
				"#finalScoreComponent",
				this.tweenSpeeds.dur.finalScoreEnter,
				{
					x: "100%",
					opacity: 0,
					ease: Power2.easeInOut,
					onComplete: done
				}
			);
		},
		handlePlayAgainButtonEnter: function(el, done) {
			TweenMax.to(el, this.tweenSpeeds.dur.itemFadeIn, {
				delay: 1.5,
				opacity: 1,
				ease: Power2.easeInOut,
				onComplete: done
			});
		},
		handlePlayAgainButtonLeave: function(el, done) {
			TweenMax.to(el, this.tweenSpeeds.dur.itemFadeIn, {
				opacity: 0,
				ease: Power2.easeInOut,
				onComplete: done
			});
		},
		handlePlayAgainButtonClick: function() {
			this.$store.dispatch("setAppStateForPlayAgain");
			this.$store.dispatch("setRoomsDataForPlayAgain");
		},

		hideContent() {
			TweenMax.to(`.${this.$style.contentWrapper}`, 0.4, {
				autoAlpha: 0
			});
		}
	}
};
</script>

<style lang='scss' module>
@import "../../assets/css/globals.scss";

.wrapper {
	display: flex;
	justify-content: center;
	align-items: center;

	height: 100%;
	width: 100%;

	background-color: red;
}

#finalScoreComponent {
	transform: translateX(100%);
}

.canvas-wrapper {
	height: 100%;
	width: 100%;
}
.planes {
	z-index: 0;
}

.fade-enter-active {
	transition: all 0.3s ease;
}
.fade-leave-active {
	transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}
.fade-enter,
.fade-leave-to {
	transform: translateX(10px);
	opacity: 0;
}

.content-wrapper {
	position: absolute;
	top: 50%;
	left: 50%;
	z-index: 10;
	max-width: 600px;
	width: 100%;
	padding-left: 20px;
	padding-right: 20px;

	transform: translate(-50%, -50%);
	box-sizing: border-box;

	color: white;
	font-weight: 700;
	text-align: center;
	text-shadow: 0 0 10px rgba(black, 0.25);

	pointer-events: none;

	@include large {
		top: 30%;
	}
}

.form-thanks {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  height: 100%;
  width: 100%;

  .info-wrapper {
     display: block;
    position: absolute;
    padding: 20px;
    width: 320px;
    height: 220px;
    border-radius: 20px;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    box-sizing: border-box;
    color: black;
    background: white;
    text-align: center;
    z-index: 100;
    box-shadow: 0 0 30px rgba(0,0,0,0.4);
    z-index: 900;

    p {
      line-height: 1.6em;
      font-size: 1em;
      font-weight: bold;
    }
  }


  &:after {
    content: '';
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0,0,0,0.65);
    z-index: 800;
  }
}

.content-title {
	margin-bottom: 8px;
	line-height: 1.3;
	font-size: 20px;
	font-weight: 800;
	text-transform: uppercase;

	@include large {
		font-size: 22px;
	}
}

.content-subtitle {
	margin-bottom: 32px;

	@include medium {
		font-size: 18px;
	}
}

.content {
	line-height: 1.2;
	max-width: 450px;
	margin-right: auto;
	margin-left: auto;

	@include large {
		line-height: 1.7;
	}
}

.commercial-video-container {
	position: absolute;
	top: 0;
	left: 0;
	z-index: 1;

	width: 100%;
	height: 50%;

	background-color: green;

	@include large {
		top: 0;
		left: 0;

		width: 50%;
		height: 100%;
	}

	overflow: hidden;

	cursor: pointer;
}

.residential-video-container {
	position: absolute;
	bottom: 0;
	left: 0;
	z-index: 1;

	width: 100%;
	height: 50%;

	background-color: green;

	@include large {
		top: 0;
		right: 0;
		left: auto;

		width: 50%;
		height: 100%;
	}

	overflow: hidden;

	cursor: pointer;
}

.commercial-video {
	height: 100%;
	width: 100%;
	object-fit: cover;
}

.residential-video {
	height: 100%;
	width: 100%;
	object-fit: cover;
}

.splash-screen-start-card {
	position: absolute;
	top: 0;
	bottom: 0;
	z-index: 2;
	height: 100%;
	width: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;

	background: linear-gradient(
		0deg,
		rgba(0, 0, 0, 0.7) 0%,
		rgba(0, 0, 0, 0.2) 65%,
		rgba(0, 0, 0, 0.05) 85%,
		rgba(255, 255, 255, 0) 100%
	);
}

.residential-splash-card {
	right: 0;
}

.commercial-splash-card {
	left: 0;
}

.video-overlay {
	position: absolute;
	top: 0;

	width: 100%;
	height: 100%;

	background-color: rgba(0, 0, 0, 0.5);

	opacity: 0;
}

.commercial-video-overlay {
	content: "";
}

.residential-video-overlay {
	content: "";
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/MainView.vue